import React from 'react'
import axios from 'axios'
import GatsbyConfig from '../../../gatsby-config.js'
import { getEl, setInLocal, trackEvent } from '../../utils/app-helpers'
import { saveData, validateRequired, validateEmail } from '../../utils/forms'
import SiteFooter from '../partials/site-footer'
import HelmetWrapper from '../partials/helmet-wrapper'
import PhoneCallout from '../partials/phone-callout'
import SiteHeader from '../partials/site-header'

const { siteMetadata: config } = GatsbyConfig

export default class ContactUsPage extends React.Component {
  static BLANK_FORM_DATA = {
    firstName: '',
    lastName: '',
    email: '',
    message: '',
  }

  constructor() {
    super()
    this.onInputChange = this.onInputChange.bind(this)
    this.state = { isBusy: false }
  }

  componentDidMount() {
    const { trip } = this.props

    setInLocal('lsg.last-viewed-trip', trip)
    this.validateDataKeys = Object.keys(ContactUsPage.BLANK_FORM_DATA)
    this.liveChecking = false
  }

  onInputChange() {
    this.data = saveData('lsg.contact-data')
    if (this.liveChecking) {
      validateRequired('lsg.contact-data', this.validateDataKeys)
      validateEmail('lsg.contact-data', ['email'])
    }
  }

  submit() {
    this.data = saveData('lsg.contact-data')
    if (
      !validateRequired('lsg.contact-data', this.validateDataKeys) ||
      !validateEmail('lsg.contact-data', ['email'])
    ) {
      this.liveChecking = true
      return
    }
    const { trip } = this.props
    const tripData = config.trips[trip] || {}
    const formEl = getEl('.contact-us form')
    const endpoint = process.env.GATSBY_ENDPOINT_CONTACT
    const { protocol, hostname, port } = window.location
    const params = {
      ...this.data,
      trip,
      returnPathRoot: `${protocol}//${hostname}${
        port ? ':' + port : ''
      }/${trip}`,
      tripDates: tripData.dates,
      tripName: tripData.name,
      tripYear: tripData.year,
      tripRegion: tripData.region,
      tripVenue: tripData.venue,
    }
    let keyPairs = []
    for (let key in params) {
      keyPairs.push(`${key}=${encodeURIComponent(params[key])}`)
    }

    formEl.classList.remove('sent', 'failed')
    this.setState({ isBusy: true })

    axios
      .post(`${endpoint}?${keyPairs.join('&')}`, {
        headers: config.axiosHeaders,
      })
      .then(function() {
        formEl.classList.add('sent')
        formEl.reset()
        setInLocal('lsg.contact-data', ContactUsPage.BLANK_FORM_DATA)
      })
      .catch(function() {
        formEl.classList.add('failed')
      })
      .finally(
        function() {
          this.setState({ isBusy: false })
        }.bind(this)
      )

    trackEvent('ViewContent', {
      content_name: `${tripData.name} ${tripData.year}`,
    })
  }

  render() {
    let data = { ...ContactUsPage.BLANK_FORM_DATA }
    try {
      const raw = localStorage.getItem('lsg.contact-data')
      if (raw) data = JSON.parse(raw)
    } catch (err) {}
    const { trip } = this.props
    const { isBusy } = this.state
    const tripData = config.trips[trip] || {}
    const title = `Contact Us | ${tripData.name} ${tripData.year}`
    const description =
      'Send us a message and we will get back to you at our earliest opportunity!'

    return (
      <div className={`page-contact-us trip-${trip}`}>
        <HelmetWrapper metaTitle={title} metaDescription={description} />
        <SiteHeader trip={trip} />
        <main className="contact-us form">
          <div
            style={{ backgroundImage: 'url(/images/contact-us-splash.jpg)' }}
            className="image mobile-100x40 desktop-400"
          />
          <form
            onSubmit={e => e.preventDefault()}
            data-sent="Thank you. We'll be in touch!"
            data-failed="Whoops. We had a problem sending your message. Please try again..."
          >
            {isBusy ? (
              <div className="loader-mask">
                <p>Sending Message</p>
                <div className="loader" />
              </div>
            ) : (
              ''
            )}
            <div className="wrap">
              <div className="content">
                <h1>Contact us</h1>
                <fieldset>
                  <p className="field field-split split-name">
                    <input
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      autoComplete="given-name"
                      onChange={this.onInputChange.bind(this)}
                      defaultValue={data.firstName}
                    />
                    <input
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      autoComplete="family-name"
                      onChange={this.onInputChange.bind(this)}
                      defaultValue={data.lastName}
                    />
                  </p>
                  <p className="field">
                    <input
                      type="text"
                      name="email"
                      placeholder="Email Address"
                      autoComplete="email"
                      onChange={this.onInputChange.bind(this)}
                      defaultValue={data.email}
                    />
                  </p>
                  <p className="field">
                    <textarea
                      name="message"
                      onChange={this.onInputChange.bind(this)}
                      defaultValue={data.message}
                    />
                  </p>
                </fieldset>
                <p className="button-bar full">
                  <button className="btn-primary" onClick={e => this.submit(e)}>
                    Send Message
                  </button>
                </p>
              </div>
            </div>
          </form>
          <PhoneCallout />
        </main>
        <SiteFooter trip={trip} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/contact-us.js